document.addEventListener('click', (e) => {
  const button = e.target.closest('[ref="addToCartButton"]');
  if (!button) return;

  const scope = button.closest('.shopify-section') || document;

  const addonCard = scope.querySelector('[data-u-addon-card]');
  const addonCheckbox = scope.querySelector('[data-u-addon-checkbox]');

  if (!addonCard || !addonCheckbox || !addonCheckbox.checked) return;

  const addonVariantId = addonCard.dataset.addonVariantId;
  if (!addonVariantId) {
    console.warn('Addon variant id missing — check addon_product setting.');
    return;
  }

  setTimeout(async () => {
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: addonVariantId, quantity: 1 }] })
      });
      const sectionsRes = await fetch(`${window.location.pathname}?sections=cart-drawer-section`);
      const sectionsData = await sectionsRes.json();
      const newHtml = sectionsData['cart-drawer-section'];
      if (newHtml) {
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(newHtml, 'text/html');

        const newInner = newDoc.querySelector('[data-hydration-key="cart-drawer-inner"]');
        const oldInner = document.querySelector('[data-hydration-key="cart-drawer-inner"]');

        if (newInner && oldInner) {
          oldInner.replaceWith(newInner);
        }
      }

      const cart = await fetch('/cart.js').then(r => r.json());
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { cart }
      }));

    } catch (err) {
      console.error('Addon add-to-cart failed:', err);
    }
  }, 700);
}, true);

document.addEventListener('click', (e) => {
  if (e.target.matches && e.target.matches('[data-u-addon-checkbox]')) {
    e.stopPropagation();
  }
});